import get from 'lodash/get';

/**
 * pull out parameters from results object
 * @param {object} results - unwrapped experiment object
 * @returns {Array} list of variants/parameters associated with experiment
 */
const filterParameters = results => {
  return get(results, 'variations', []);
};

/**
 * normalize experiment result
 * @param {object} experimentResult - experiment result
 * @returns {object} normalized result
 */
const normalizer = (experimentResult = {}) => {
  if (experimentResult.experiment) {
    return {
      name: experimentResult.experiment,
      parameters: filterParameters(experimentResult)
    };
  }

  return {
    name: undefined,
    parameters: undefined
  };
};

export default normalizer;
